export default "__VITE_ASSET__C7yMqc6d__"